import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';

export const addToFavorites = async (userEmail, auctionId) => {
  const addToFavoritesFn = httpsCallable(functions, 'addToFavoritesV2');
  try {
    const result = await addToFavoritesFn({
      userEmail,
      auctionId,
      requestedApp: 'reseller_app',
    });
    return result.data;
  } catch (error) {
    console.error('Error adding to favorites:', error);
    return { success: false, error: error.message };
  }
};
